module.exports = __webpack_public_path__ + "static/media/权益九@2x.24e863bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_121/img/权益九@2x.png
// module id = 1144
// module chunks = 0